import React from 'react';
import { IconProps } from '../types';

export const ErrorIcon = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" height={16} width={16} {...props}>
    <path
      className={props.fill ?? 'fill-negative-normal'}
      d="M7 13.667A6.667 6.667 0 1 1 7 .334a6.667 6.667 0 0 1 0 13.333Zm0-1.333A5.333 5.333 0 1 0 7 1.667a5.333 5.333 0 0 0 0 10.667Zm-.667-3.333h1.334v1.333H6.333V9.001Zm0-5.334h1.334v4H6.333v-4Z"
    />
  </svg>
);
